export const flags = {
  ENABLE_ACCOUNT_ACTIVITY_LOG: 'ENABLE_ACCOUNT_ACTIVITY_LOG',
  ENABLE_NEW_ACTIVITY_API: 'ENABLE_NEW_ACTIVITY_API',
  ENABLE_NAMESPACES: 'ENABLE_NAMESPACES',
  ENABLE_CUSTOMER_REPORTING: 'ENABLE_CUSTOMER_REPORTING',
};
